import { authorizedInstance } from "../config/axios"

export const getGlobalSettings = async () => {
  const response = await authorizedInstance.get("/global-settings")
  return response.data
}

export const updateGlobalSetting = async ({ key, value }) => {
  const response = await authorizedInstance.put(`/global-settings/${key}`, {
    value,
  })
  return response.data
}

export const getGlobalSettingHistory = async ({
  key,
  offset = 0,
  limit = 10,
}) => {
  const params = new URLSearchParams({ offset, limit })
  const response = await authorizedInstance.get(
    `/global-settings/${key}/history?${params}`
  )
  return response.data
}
